import { createApi } from '@reduxjs/toolkit/query/react';
import { authQuery } from '../config/query.config';
import {
  ErrorResponse,
  GetRedeemableBadgesResponse,
} from 'app/(app)/dashboard/badges/badges.typings';

export const redeemApi = createApi({
  reducerPath: 'redeem-api',
  baseQuery: authQuery,
  tagTypes: ['RedeemableBadges'],
  endpoints: (builder) => ({
    // GET /redeemable-badges/:fanId?redeemed=false
    getRedeemableBadges: builder.query<
      GetRedeemableBadgesResponse,
      { fanId: string; redeemed?: boolean }
    >({
      query: ({ fanId, redeemed = false }) => ({
        url: `/redeemable-badges/${fanId}?redeemed=${redeemed}`,
        method: 'GET',
      }),
      transformResponse: (response: GetRedeemableBadgesResponse | ErrorResponse) => {
        if ('error' in response) {
          throw new Error(response.error);
        }
        return response;
      },
      providesTags: ['RedeemableBadges'],
    }),

    // PUT /redeem-badge/:instanceId
    redeemBadge: builder.mutation<any, { instanceId: string }>({
      query: ({ instanceId }) => ({
        url: `/redeem-badge/${instanceId}`,
        method: 'PUT',
      }),
      transformResponse: (response: any | ErrorResponse) => {
        if ('error' in response) {
          throw new Error(response.error);
        }
        return response;
      },
      invalidatesTags: ['RedeemableBadges'],
    }),
  }),
});

export const { useGetRedeemableBadgesQuery, useRedeemBadgeMutation } = redeemApi;
